import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';
import { hzNavigate } from '../utils/navigation';
import { Box, Card, Icon, Link, Text, Grid, Cell } from '@houzz/ui/';
import { InverseButton } from '@houzz/ui/button';
import { ArrowRight } from '@houzz/icons/ArrowRight';
import Layout from '../components/layout';
import SEO from '../components/seo';
import videoFile from '../images/homepage_video.mp4';

import './home.css';

const HomeCard = ({ title, description, href, bg, imgSrc, span = '1' }) => {
    const clickHandler = (event) => hzNavigate(event, href);

    return (
        <Cell
            as="li"
            display="flex"
            flex="auto"
            flexBasis="30.5%"
            flexDirection="column"
            justifyContent="flex-start"
            col={`span ${span}`}
        >
            <Box bg={bg} flex="0 0 220px" display="flex" m="0">
                <a href={href} onClick={clickHandler}>
                    <img src={imgSrc} alt="thumbnail" />
                </a>
            </Box>
            <Text fontWeight="bold" my="M">
                {title}
            </Text>
            <Text as="p" size="small" mt="Zero" mb="XS">
                {description}
            </Text>
            <Link href={href} variant="primary" size="small" fontWeight="bold" mt="auto" onClick={clickHandler}>
                Learn More
            </Link>
        </Cell>
    );
};

HomeCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    href: PropTypes.string,
    bg: PropTypes.string,
    span: PropTypes.string,
    imgSrc: PropTypes.string,
};

const IndexPage = () => {
    return (
        <Layout>
            <SEO title="Home" />
            <Box as="section" className="hero" bg="#00342B" color="content.inverse" pt="XXXL">
                <Box
                    width="85%"
                    display="flex"
                    mx="auto"
                    position="relative"
                    height="693px"
                    justifyContent="space-between"
                >
                    <Box flex="1 1 620px" maxWidth="800px" pr="70px" alignSelf="center" position="relative" zIndex="10">
                        <Text
                            as="h1"
                            className="site-title"
                            mt="Zero"
                            size="4.2rem"
                            lineHeight="5.2rem"
                            fontWeight="bold"
                        >
                            Welcome to
                            <br />
                            Houzz Design
                        </Text>
                        <Text as="p">
                            Our design system site is created to provide components and tools to help product, marketing
                            and brand teams work more efficiently, and to make our overall brand cohesive.
                        </Text>

                        <InverseButton
                            variant="outline"
                            href={withPrefix('/components')}
                            size="large"
                            icon={<Icon as={ArrowRight} />}
                            iconAlign="end"
                            onClick={(event) => hzNavigate(event, '/components')}
                        >
                            Get Started
                        </InverseButton>
                        <InverseButton
                            href={withPrefix('/introduction')}
                            variant="text"
                            colorVariant="neutral"
                            color="content.inverse"
                            size="large"
                            mt="auto"
                            onClick={(event) => hzNavigate(event, '/introduction')}
                            ml="M"
                        >
                            Introduction
                        </InverseButton>
                    </Box>
                    <Box flex="0 0 475px">
                        <video autoPlay={true} loop={true} muted={true}>
                            <source src={videoFile} type="video/mp4" />
                        </video>
                    </Box>
                </Box>
            </Box>

            <Box as="section" className="featured">
                <Grid
                    as="ul"
                    className="featured-sections-list"
                    gridTemplateColumns="repeat(2, 1fr)"
                    gridGap="40px 30px"
                    m="1rem auto"
                    width="80%"
                >
                    <HomeCard
                        title="Components"
                        description="Components are a collection of reusable building blocks used by Houzz to efficiently create beautiful products for your users."
                        href="/components"
                        bg="accentTint"
                        imgSrc="homepage_thumbnail_component.png"
                    />
                    <HomeCard
                        title="Foundations"
                        description="Foundations are the visual standards used to define components, layouts, and experiences for our users."
                        href="/foundations"
                        bg="blue.tint4"
                        imgSrc="homepage_thumbnail_foundation.png"
                    />
                    <HomeCard
                        title="Brand"
                        description="Our brand guidelines are a reflection of who we are and how we want our home enthusiasts and professionals to feel when using our products."
                        href="/brand"
                        bg="green.tint4"
                        imgSrc="homepage_thumbnail_brand.png"
                    />
                    {/*}
                    <HomeCard
                        title="Marketing"
                        description="Our marketing guidelines are about understanding who our customers are and how we communicate, build and maintain relationships with them."
                        href="/marketing"
                        bg="pink.tint4"
                        imgSrc="homepage_thumbnail_marketing.png"
                        />*/}
                    <HomeCard
                        title="Content Style Guide"
                        description="Our content style guide informs writing style and terminology for all communications and creates a cohesive, consistent writing direction for our brand personality."
                        href="/writing"
                        bg="yellow.tint4"
                        imgSrc="homepage_thumbnail_contentstyleguide.png"
                    />
                    <HomeCard
                        title="Want to contribute?"
                        description="We welcome all feedback, designs, or ideas so Houzz can provide the best experience for homeowners and home renovation and design professionals."
                        href="/contribute"
                        bg="magenta.tint4"
                        imgSrc="homepage_thumbnail_contribute.png"
                    />
                </Grid>
            </Box>
        </Layout>
    );
};

export default IndexPage;
